export default "__VITE_ASSET__69758237__"